import PropTypes from 'prop-types'

import { AdasPaper } from '@components/wrapper-components'

export const StickyFooter = ({ children, className = '' }) => {
  return (
    <AdasPaper className={`w-[inherit] py-[20px] ${className}`} elevation={0}>
      {children}
    </AdasPaper>
  )
}

StickyFooter.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}
